import { get, set, merge, pickBy } from 'lodash';
import { handleActions } from 'redux-actions';
import { CALCULATE_FONT_USAGE } from '../../../constants/ActionTypes';
import * as ActionTypes from '../../../constants/ActionTypes';
import { FontFamilyProperty } from '../../../../lib/css-property-parser/FontFamilyProperty';
import { webSafeFontsNames } from '../../../constants/availableFonts';
/**
 * This array contains properties to track and look for font usage
 * Item path format: [FontFamily, FontStyle|null, FontWeight|null]
 * @type {Array}
 */
const fontTracking = [
    ['buttons.button.link.font', 'buttons.button.link.style', 'buttons.button.link.weight'],
    ['buttons.button.primary.font', null, 'buttons.button.primary.weight'],
    ['buttons.button.secondary.font', null, 'buttons.button.secondary.weight'],
    ['global.h1.fontFamily', null, 'global.h1.fontWeight'],
    ['global.h2.fontFamily', null, 'global.h2.fontWeight'],
    ['global.h3.fontFamily', null, 'global.h3.fontWeight'],
    ['global.h4.fontFamily', null, 'global.h4.fontWeight'],
    ['global.h5.fontFamily', null, 'global.h5.fontWeight'],
    ['header.userBar.font', null, 'header.userBar.fontWeight'],
    ['form.input.font', 'form.input.style', 'form.input.weight'],
    ['globalBar.globalBar.title.desktop.font', null, 'globalBar.globalBar.title.desktop.fontWeight'],
    ['globalBar.globalBar.title.tablet.font', null, 'globalBar.globalBar.title.tablet.fontWeight'],
    ['globalBar.globalBar.title.mobile.font', null, 'globalBar.globalBar.title.mobile.fontWeight'],
    ['globalBar.globalBar.subtitle.desktop.font', null, 'globalBar.globalBar.subtitle.desktop.fontWeight'],
    ['globalBar.globalBar.subtitle.tablet.font', null, 'globalBar.globalBar.subtitle.tablet.fontWeight'],
    ['globalBar.globalBar.subtitle.mobile.font', null, 'globalBar.globalBar.subtitle.mobile.fontWeight'],
    ['globalBar.globalBar.link.font', null, 'globalBar.globalBar.link.fontWeight'],
    ['globalBar.globalBar.cart.price.font', null, 'globalBar.globalBar.cart.price.fontWeight']
];

const fontsDataReducer = handleActions(
    {
        [CALCULATE_FONT_USAGE]: (state, action) => {
            const fontsUsage = {};
            fontTracking.forEach(([fontFamilyPath, fontStylePath, fontWeightPath]) => {
                const fontFamilies = new FontFamilyProperty(get(state, `app.data.theme.${fontFamilyPath}`, ''));
                if (!fontFamilies.error) {
                    fontFamilies.value.forEach(fontFamily => {
                        if (fontFamily) {
                            const fontLibrary = get(state, ['theme', 'fonts', fontFamily, 'files'], {}); //, fontStyle.ucFirst() + ':' + fontWeight
                            /*
                        const fontStyle = fontStylePath ? get(state, `app.data.theme.${fontStylePath}`, 'Normal') : 'Normal';
                        const fontWeight = fontWeightPath ? get(state, `app.data.theme.${fontWeightPath}`, 400) : 400;
                        const fontFiles = get(state, ['theme', 'fonts', fontFamily, 'files', fontStyle.ucFirst() + ':' + fontWeight], {});
                        const fontKey = `${fontFamily}:${fontStyle.ucFirst()}:${fontWeight}`;
                        if (!fontsUsage[fontKey]) {
                            fontsUsage[fontKey] = { files: fontFiles, isWebSafe: webSafeFontsNames.indexOf(fontFamily) !== -1 };
                        }*/
                            Object.keys(fontLibrary).forEach(fontVariant => {
                                const files = get(fontLibrary, [fontVariant], []);
                                fontsUsage[`${fontFamily}:${fontVariant}`] = {
                                    files: files,
                                    isWebSafe: webSafeFontsNames.indexOf(fontFamily) !== -1
                                };
                            });
                        }
                    });
                }
            });
            const nonWebSafe = pickBy(fontsUsage, o => !o.isWebSafe && o.files && o.files.length > 0);
            set(state, 'app.data.theme.fontsUsage', nonWebSafe);
            set(state, 'theme.fontsUsage', fontsUsage);
            set(state, 'save.changed', state.save.changed || !!action.changed);
            set(state, 'save.themeChange', state.save.themeChange || !!action.changed);
            return { ...state };
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('fontsUsage')) {
                const changedState = { ...state };
                set(changedState, 'app.data.theme.fontsUsage', action.theme.fontsUsage);
                return changedState;
            } else {
                return state;
            }
        }
    },
    {}
);

export default fontsDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/fonts.js